import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';
import { ModalAddMassBeneficiaireComponent } from "src/app/parametres/param-production/param-production-avancee/beneficiaire/modal-add-mass-beneficiaire/modal-add-mass-beneficiaire.component";
import { ModalAddBeneficiaireComponent } from "src/app/parametres/param-production/param-production-avancee/beneficiaire/modal-add-beneficiaire/modal-add-beneficiaire.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";
import { ModalAddGarantComponent } from "src/app/parametres/param-production/param-production-avancee/garant/modal-add-garant/modal-add-garant.component";
import { ModalViewPoliceDetailsComponent } from "src/app/shared/components/modal-view-police-details/modal-view-police-details.component";
import { ModalAddPoliceComponent } from "src/app/parametres/param-production/param-production-avancee/police/modal-add-police/modal-add-police.component";
import { ModalViewCollegeDetailComponent } from "src/app/shared/components/modal-view-college-detail/modal-view-college-detail.component";
import { ModalAddCollegeComponent } from "src/app/parametres/param-production/param-production-avancee/college/modal-add-college/modal-add-college.component";
import { ModalAddAvenantComponent } from "src/app/parametres/param-production/param-production-base/avanant/modal-add-avenant/modal-add-avenant.component";


@Component({
  selector: 'app-list-beneficiaire-to-check',
  templateUrl: './list-beneficiaire-to-check.component.html',
  styleUrls: ['./list-beneficiaire-to-check.component.scss']
})
export class ListBeneficiaireToCheckComponent implements OnInit {

  listItems: Array<any> = [];
  @Output() onSendData= new EventEmitter<any>();
  @Input() type_avenant_codifications:any;
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id:any
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "beneficiaire";
  title:string='beneficiaire'
  createMessage = ''
  editMessage =''
  deleteMessage =''
  itemsParentFonctionnalites=[]

  gender='F'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite:any=[]
  itemsGenre:any=[]
  itemsFiliale:any=[]
  searchKey:any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword=false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  @Output() goToNextTab = new EventEmitter();
  itemsGarant: any;
  itemsSouscripteur: any;
  itemsPolice: any;
  itemsCollege: any;
  itemsStatut: any;
  itemsStatutInitialized: any[];
  itemsAvenant: any;

  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    let text1 = this.gender=='M'?'un':'une'
    this.createMessage = 'Vous êtes sur le point de créer '+text1+' '+this.title
    this.editMessage = 'Vous êtes sur le point de modifier '+text1+' '+this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer '+text1+' '+this.title


  }

  pageChanged(event: any): void {
    this.currentPage = event.page-1;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }
  load_filiale_data(){}

  onLoadExcelBenef(event){
    console.log('event: ',event)
    this.openAddMassBeneficiaire(event)
  }
  openAddMassBeneficiaire(data) {
    let modal: any;
    modal = ModalAddMassBeneficiaireComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 100,
      class: "gray modal-lg modal-width-100",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    console.log('data excel: ',data)
    this.modalRef.content.currentData = {data:data,values:{garant_id:this.itemToSave.garant_id,police_id:'',college_id:'',is_lock_header:false}};
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0;
      // this.closeModal()
      this.getItems();
    });
  }

  
  removeEmptyValues(obj) {
    return Object.keys(obj)
      .filter(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      type_avenant_codifications:this.type_avenant_codifications,
      data: {...this.removeEmptyValues(this.itemToSearch)},
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getListCanBeMouvement", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res['hasError']) {
            this.items = res["items"];
            
            this.totalItems = res["count"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => { }
      );
  }


  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  
  // openAddItemModal(data?) {
  //   let modal: any;
  //   modal = ModalAddBeneficiaireComponent;
  //   this.modalRef = this.modalService.show(modal, {
  //     id: 59,
  //     class: "modal-width-90",
  //     ignoreBackdropClick: true,
  //     // data:boulangerie
  //   });
  //   if (data) this.modalRef.content.currentData = data;
  //   this.modalRef.onHide.subscribe((res) => {
  //     this.currentPage = 0;
  //     this.getItems();
  //   });
  // }
  handleImageError(item){
    item.image_url = 'assets/images/custom/user-ano.jpeg'
  }
  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);

          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id:this.itemToSearch.garant_id
      },
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsSouscripteur = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => {
          this.itemsSouscripteur = [];
        }
      );
  }
  getItemsPolice() {
    if(!this.itemToSearch.garant_id){
      return
    }
    // if(!this.itemToSearch.garant_id || !this.itemToSearch.souscripteur_id){
    //   return
    // }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id:this.itemToSearch.garant_id,
        souscripteur_id:this.itemToSearch.souscripteur_id
      },
    };

    this.busyGet = this.restClient
      .post("police/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPolice = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsPolice = [];
          }
        },
        (err) => {
          this.itemsPolice = [];
        }
      );
  }
  getItemsCollege() {
    if(!this.itemToSearch.police_id){
      return
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        police_id:this.itemToSearch.police_id
      },
    };

    this.busyGet = this.restClient
      .post("college/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCollege = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCollege = [];
          }
        },
        (err) => {
          this.itemsCollege = [];
        }
      );
  }

  onChangeGarant(){
    this.getItemsPolice()
  }
  onChangeSoucripteur(){
    this.getItemsPolice()
  }

  onChangePolice(){
    this.getItemsCollege()
  }

  openModalDetailGarant() {
    if(!this.itemToSearch.garant_id){
      return
    }
    let modal: any;
    modal = ModalViewGarantDetailsComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let data = {id:this.itemToSearch.garant_id}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  openAddGarantModal(data?){
    let modal: any;
    modal = ModalAddGarantComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.getItemsGarant()
    });
  }
  openModalDetailPolice() {
    if(!this.itemToSearch.police_id){
      return
    }
    let modal: any;
    modal = ModalViewPoliceDetailsComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let data = {id:this.itemToSearch.police_id}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  openAddPoliceModal(data?){
    let modal: any;
    modal = ModalAddPoliceComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.getItemsPolice()
    });
  }
  openModalDetailCollege() {
    if(!this.itemToSearch.college_id){
      return
    }
    let modal: any;
    modal = ModalViewCollegeDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let data = {id:this.itemToSearch.college_id}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  openAddCollegeModal(data?){
    let modal: any;
    modal = ModalAddCollegeComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.getItemsCollege()
    });
  }

  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }
  openAddAvenant(data?) {
    let modal: any;
    modal = ModalAddAvenantComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 58,
      class: "modal-width-50",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0;
      this.getItemsAvenant();
    });
  }

  getItemsAvenant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      type_avenant_codifications:this.type_avenant_codifications,
      data: {},
    };

    this.busyGet = this.restClient
      .post("avenant/getByTypeList", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAvenant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsAvenant = [];
          }
        },
        (err) => {
          this.itemsAvenant = [];
        }
      );
  }

  openModal(data: any, template: TemplateRef<any>) {
    
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-90",
    };
    this.itemToSave = {};
    if (data) {
 
      this.itemToSave = Object.assign({}, data);
    }

    this.modalRef = this.modalService.show(template, config);
  }

  checkUnchek(){
    let checkedItems = this.items.filter(it=>it.isChecked)
    console.log('checkedItems: ',checkedItems)
    this.onSendData.emit(checkedItems)

  }
  ngOnInit() {
    this.getItems();
    this.getItemsFiliale();
    this.getItemsGarant()
    this.getItemsSouscripteur()
    this.getItemsAvenant()

  }


}
